/*
 * @Author: Risker-C
 * @Date: 2021-09-13 17:25:20
 * @LastEditTime: 2021-09-17 10:12:15
 * @LastEditors: Risker-C
 * @Description: 
 * @FilePath: \yh-wms\src\layout\AppRoute.tsx
 */
import React from "react";
import { Switch, Route } from "react-router-dom";
import { Home } from "../views/home/Home";
import { Basic } from "../views/base/basic/view";
import { Friendship } from "../views/base/friendship/view";
import { Company } from "../views/base/company/view";
import { Team } from "../views/base/team/view";
import { Interal } from "../views/projectCase/internal/view";
import { Abroad } from "../views/projectCase/abroad/view";
import { DetailsBox as InteralDetailsBox } from "../views/projectCase/internal/view/DetailsBox";
import { DetailsBox as AbroadDetailsBox } from "../views/projectCase/abroad/view/DetailsBox";
import { DetailsBox as CompanyDetailsBox } from "../views/content/company/view/DetailsBox";
import { DetailsBox as VideoDetailsBox } from "../views/content/video/view/DetailsBox";


import { DictBox } from "../views/base/dict/view/DataBox"

import Error404 from "../views/404";
import { CompanyNews } from "@/views/content/company/view";
import { Video } from "@/views/content/video/view";
import { Business } from "@/views/business/view";
import { DetailsBox as BusinessDetail } from "@/views/business/view/DetailsBox";

function AppRoute() {
    return (
        <Switch>
            <Route exact={true} path={"/"} key="2-1" component={Basic} />
            {/* <Route exact={true} path={"/base/basic"} key="2-1" component={Basic} /> */}
            <Route exact={true} path={"/base/friendship"} key="2-2" component={Friendship} />
            <Route exact={true} path={"/base/company"} key="2-3" component={Company} />
            <Route exact={true} path={"/base/dict"} key="2-5" component={DictBox} />
            <Route exact={true} path={"/base/team"} key="2-4" component={Team} />
            <Route exact={true} path={"/projectCase/internal"} key="3-1" component={Interal} />
            <Route exact={true} path={"/projectCase/internal"} key="3-1" component={Interal} />
            <Route exact={true} path={"/content/company"} key="4-1" component={CompanyNews} />
            <Route exact={true} path={"/content/company/add"} key="4-1-1" component={CompanyDetailsBox} />
            <Route exact={true} path={"/content/company/edit"} key="4-1-2" component={CompanyDetailsBox} />
            <Route exact={true} path={"/content/video"} key="4-2" component={Video} />
            <Route exact={true} path={"/content/video/add"} key="4-2-1" component={VideoDetailsBox} />
            <Route exact={true} path={"/content/video/edit"} key="4-2-2" component={VideoDetailsBox} />

            <Route exact={true} path={"/projectCase/internal/add"} key="3-1-1" component={InteralDetailsBox} />
            <Route exact={true} path={"/projectCase/internal/edit"} key="3-1-2" component={InteralDetailsBox} />
            <Route exact={true} path={"/projectCase/abroad/add"} key="3-2-1" component={AbroadDetailsBox} />
            <Route exact={true} path={"/projectCase/abroad/edit"} key="3-2-2" component={AbroadDetailsBox} />
            <Route exact={true} path={"/projectCase/abroad"} key="3-2" component={Abroad} />

            <Route exact={true} path={"/business"} key="5-1" component={Business} />
            <Route exact={true} path={"/business/add"} key="5-1-1" component={BusinessDetail} />
            <Route exact={true} path={"/business/edit"} key="5-1-2" component={BusinessDetail} />


            <Route exact={true} path={"/*"} key="404" component={Error404} />
        </Switch>
    )
}

export default AppRoute;